export {
  type GraphemeDefinitionPrcData,
  graphemeDefinitionPrcDataTable,
} from "#grapheme-definition-prc-data-table";
